export const isAndroidDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  return /android/i.test(userAgent);
};

export const isIOSDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

export const downloadAppleWalletPass = (blob) => {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "popcard.pkpass";
  document.body.appendChild(anchor);
  anchor.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(anchor);
};

export const addCollaboratorToWallet = async ({
  collaboratorId,
  generateAppleWalletPass,
  generateGoogleWalletPass,
}) => {
  if (isAndroidDevice()) {
    const response = await generateGoogleWalletPass(collaboratorId).unwrap();
    const saveUrl = response?.data?.saveUrl ?? response?.saveUrl;

    if (!saveUrl) {
      throw new Error("Google Wallet save URL not found");
    }

    window.location.href = saveUrl;
    return "google";
  }

  const blob = await generateAppleWalletPass(collaboratorId).unwrap();
  downloadAppleWalletPass(blob);
  return isIOSDevice() ? "ios" : "apple";
};
